import "./App.css";
import * as React from "react";
import Button from "@mui/material/Button";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useState, useEffect, useCallback, useRef } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import FormDialog from "/Users/danield/react-files/world-clock/src/Components/dialog.js";
import responsiveFontSizes from "@mui/material/styles/responsiveFontSizes";
import "./fonts/Lexend-VariableFont_wght.ttf";
import createTheme from "@mui/material/styles/createTheme";
import ThemeProvider from "@mui/material/styles/ThemeProvider";
import TeamList from "./Components/TeamList";
import WeatherWidget from "./Components/WeatherWidget";

let darkTheme = createTheme({
	breakpoints: {
		values: {
			xs: 0,
			sm: 450,
			md: 900,
			lg: 1200,
			xl: 1536,
		},
	},
	components: {
		MuiAvatar: {
			styleOverrides: {
				root: {
					height: "48px",
					width: "48px",
					boxShadow:
						"0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)",
				},
			},
			variants: [
				{
					props: { variant: "smallest" },
					style: { width: "42px", height: "42px" },
				},
			],
		},
		MuiGrid: {
			variants: [
				{
					props: { variant: "isHovering" },
					style: {
						color: "rgb(0, 154, 237)",
						backgroundColor: "rgba(216, 216, 216, 0.805)",
						boxShadow: "2px 1px 18px -1px black",
					},
				},
			],
		},
	},
	palette: { mode: "light" },
	typography: {
		fontFamily: "Lexend, Arial",
		h1: {
			fontSize: "6rem",
			fontWeight: 800,
		},
		h2: {
			fontSize: "4.75rem",
			fontWeight: 800,
		},
		h3: {
			fontSize: "3rem",
			fontWeight: 400,
		},
		h4: {
			fontSize: "2.125rem",
			fontWeight: 400,
		},
		subtitle1: {
			fontSize: "1rem",
			fontWeight: 400,
		},
		subtitle2: {
			fontSize: ".875rem",
			fontWeight: 500,
		},
		body1: {
			fontSize: "1rem",
			fontWeight: 400,
		},
		body2: {
			fontSize: ".875rem",
			fontWeight: 400,
		},
		body3: {
			fontSize: ".75rem",
			fontWeight: 400,
		},
		caption: {
			fontSize: "1rem",
			fontWeight: 400,
		},
		extraBold: {
			fontWeight: 800,
		},
		bold: {
			fontWeight: 700,
		},
		semibold: {
			fontWeight: 600,
		},
		medium: {
			fontWeight: 500,
		},
		regular: {
			fontWeight: 400,
		},
		light: {
			fontWeight: 300,	
		},
		bodyTitle: {
			fontSize: "18px",
			fontWeight: 700,
		},
		bodySectionHead: {
			fontSize: "14px",
			fontWeight: 700,
		},
		listItemHead: {
			fontSize: "18px",
			fontWeight: 500,
		},
		bodySubTitle: {
			color: "#adadad",
			textTransform: "uppercase",
			fontSize: ".75rem",
		},
		bodySubTitleEm: {
			fontSize: ".75rem",
		},
	},
});

let modalTheme = createTheme({
	palette: { mode: "dark" },
	components: {
		MuiDialog: {
			styleOverrides: {
				inputRoot: {
					color: "white",
				},
				paper: {
					color: "white",
					borderRadius: "20px",
				},
			},
		},
	},
	typography: {
		fontFamily: "Lexend, Arial",
	},
});

modalTheme = responsiveFontSizes(modalTheme);

darkTheme = responsiveFontSizes(darkTheme);

let currentTimeOfDay;
function timeOfDay() {
	let hour = new Date().getHours();
	if (hour >= 4 && hour <= 11) return "Morning";
	if (hour >= 12 && hour <= 16) return "Afternoon";
	if (hour >= 17 && hour <= 20) return "Evening";
	if (hour >= 21 || hour <= 3) return "Evening";
}
currentTimeOfDay = timeOfDay();
const convertValue = 100 / 60;

function App() {
	const [ipTime, setIpTime] = useState();
	const [inputTime, setInputTime] = useState();

	const [timeArray, setTimeArray] = useState();
	const [timeData, setTimeData] = useState([]);
	const [timeObj, setTimeObj] = useState();
	const [timeoutId, setTimeoutId] = useState(null);
	const secondsRef = useRef();
	const dateNow = new Date();
	const secondsNow = dateNow.getSeconds();

	const [userIp, setUserIp] = useState();
	const [inputName, setInputName] = useState();
	const [userName, setUserName] = useState(localStorage.getItem("userName"));
	const [dialogForecastData, setDialogForecastData] = useState([]);
	const [zipCode, setZipCode] = useState();
	const [timeZoneId, setTimeZoneId] = useState();
	const [open, setOpen] = useState(false);
	const [showLookup, setShowLookup] = useState(false);
	const [dialogOpen, setDialogOpen] = useState(false);
	const [nameValue, setNameValue] = useState("");
	const [progressValue, setProgressValue] = useState();
	const [progress, setProgress] = useState(0);


	const handleZipCodeSubmit = (zipCode) => {
		setZipCode(zipCode);
	};

	useEffect(() => {
		if (!secondsRef.current) {
			secondsRef.current = secondsNow;
		} else {
			secondsRef.current = secondsRef.current + 1;
		}
		return () => setProgressValue(convertValue * secondsRef.current);
	}, [secondsNow]);

	const baseURL = "https://worldtimeapi.org/api/timezone/";
	const ipURL = "https://worldtimeapi.org/api/ip";
	const inputURL = baseURL + timeZoneId;

	const azURL = "https://worldtimeapi.org/api/timezone/America/Phoenix";
	const caURL = "https://worldtimeapi.org/api/timezone/America/Los_Angeles";
	const txURL = "https://worldtimeapi.org/api/timezone/America/Chicago";
	const eastURL = "https://worldtimeapi.org/api/timezone/America/New_York";

	const getTime = async (url) => {
		try {
			const response = await fetch(url);
			const json = await response.json();
			const client_ip = json.client_ip;
			const date = new Date(json.datetime);
			const formatter = new Intl.DateTimeFormat("en-US", {
				timeZone: json.timezone,
				hour: "2-digit",
				minute: "2-digit",
			});

			return [formatter.format(date), json, client_ip];
		} catch (error) {
			console.log(error);
		}
	};

	const getAllTimes = useCallback(async () => {
		if (timeZoneId) {
			try {
				const [mst, pst, local, tx, east, input] = await Promise.all([
					getTime(azURL),
					getTime(caURL),
					getTime(ipURL),
					getTime(txURL),
					getTime(eastURL),
					getTime(inputURL),
				]);
				setIpTime(local[0]);
				setUserIp(local[2]);
				setInputTime(input[0]);
				// setAzTime(mst[0]);
				// setCaTime(pst[0]);
				// setTxTime(tx[0]);
				// setEastTime(east[0]);

				setTimeArray([mst[0], pst[0], local[0], tx[0], east[0], input[0]]);
				setTimeData([mst[1], pst[1], local[1], tx[1], east[1], input[1]]);
				setTimeObj([
					{ timezone: { Arizona: mst[1] } },
					{ timezone: { California: pst[1] } },
					{ timezone: { Local: local[1] } },
					{ timezone: { Texas: tx[1] } },
					{ timezone: { East: east[1] } },
					{ timezone: { Input: input[1] } },
				]);

				const nextInterval = 60000 - (Date.now() % 60000);
				return [nextInterval];
			} catch (error) {
				console.log(error);
			}
		}
	}, [inputURL, timeZoneId]);

	useEffect(() => {
		const intervalId = setInterval(() => {
			const now = new Date();
			const secondsElapsed = now.getSeconds();
			const millisecondsElapsed = now.getMilliseconds();
			const percentage = Math.round(
				((secondsElapsed * 1000 + millisecondsElapsed) / 60000) * 100
			);
			setProgress((prevVal) => percentage + 1);
		}, 16.67);

		return () => clearInterval(intervalId);
	}, [timeArray, timeData]);

	useEffect(() => {
		const startTimeout = async () => {
			const nextTimeout = await getAllTimes();
			setTimeoutId(
				setTimeout(() => {
					startTimeout();
				}, nextTimeout)
			);
		};

		startTimeout();

		return () => clearTimeout(timeoutId);
	}, [getAllTimes]);

	const handleReset = () => {
		setShowLookup(false);
		setZipCode("");
		localStorage.removeItem("zipCode");
		localStorage.removeItem("hasSubmitted");
		localStorage.removeItem("userName");
		localStorage.removeItem("fullName");
		setDialogOpen(true);
		setNameValue("");
		setOpen(false);
	};

	const handleClick = () => {
		setOpen(true);
	};
	const handleClose = () => {
		setOpen(false);
	};

	return (
		<div className="App">
			<Grid container justifyContent="flex-end">
				<Grid xs>
					<Button
						id="basic-button"
						onClick={handleClick}
						endIcon={<RestartAltIcon />}>
						Reset
					</Button>
					<ThemeProvider theme={modalTheme}>
						<Dialog
							open={open}
							p={4}
							onClose={handleClose}
							sx={{
								"& .MuiDialog-paper": {
									background: `linear-gradient(127.09deg, rgba(6, 11, 40, 1) 19.41%, rgba(10, 14, 35, 1) 76.65%)`,
									width: "425px",
									height: "350px",
									alignContent: "space-between",
									justifyContent: "space-around",
									alignItems: "stretch",
								},
							}}>
							<DialogTitle variant="h5" mt={1} mb={3}>
								Reset name and zipcode
							</DialogTitle>
							<DialogContent>
								<DialogContentText variant="body1">
									This will clear your name and zipcode and you will be prompted
									to enter them again.
								</DialogContentText>
							</DialogContent>

							<DialogContent>
								<DialogContentText fontWeight="600" color="white">
									Are you sure you want to continue?
								</DialogContentText>
							</DialogContent>
							<DialogActions sx={{ padding: "12px" }}>
								<Button
									fullWidth
									variant="outlined"
									onClick={handleClose}
									sx={{ color: "white", border: "1px solid white" }}>
									Cancel
								</Button>
								<Button
									fullWidth
									variant="outlined"
									onClick={handleReset}
									color="error">
									Yes, reset
								</Button>
							</DialogActions>
						</Dialog>
					</ThemeProvider>
				</Grid>
			</Grid>

			<FormDialog
				setInputName={setInputName}
				setUserName={setUserName}
				dialogForecastData={dialogForecastData}
				setDialogForecastData={setDialogForecastData}
				setZipCode={setZipCode}
				ipTime={ipTime}
				inputTime={inputTime}
				onZipCodeSubmit={handleZipCodeSubmit}
				zipCode={zipCode}
				showLookup={showLookup}
				setShowLookup={setShowLookup}
				dialogOpen={dialogOpen}
				setDialogOpen={setDialogOpen}
				nameValue={nameValue}
				setNameValue={setNameValue}
			/>
			<ThemeProvider theme={darkTheme}>
				<Grid container gap={2}>
					{localStorage.getItem("hasSubmitted") && (
						<WeatherWidget
							currentTimeOfDay={currentTimeOfDay}
							containerWidth="true"
							ipTime={ipTime}
							inputTime={inputTime}
							userIp={userIp}
							userName={userName}
							setDialogForecastData={setDialogForecastData}
							zipCode={zipCode}
							timeZoneId={timeZoneId}
							setTimeZoneId={setTimeZoneId}
						/>
					)}
					<Grid className="grid-item" xs={12}>
						{timeArray && (
							<TeamList
								time={timeArray}
								timeArray={timeArray}
								timeData={timeData}
								timeObj={timeObj}
								ipTime={ipTime}
								inputName={inputName}></TeamList>
						)}
					</Grid>
				</Grid>
			</ThemeProvider>
		</div>
	);
}

export default App;
